import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarDayComponent } from './calendar-day.component';
import { EDayTypeToStringPipe } from 'projects/shared/lib/pipes/time/eday-type-to-string-pipe/eday-type-to-string.pipe';

@NgModule({
  declarations: [
    CalendarDayComponent,
  ],
  imports: [
    CommonModule,

    EDayTypeToStringPipe,
  ],
  exports: [
    CalendarDayComponent,
  ]
})
export class CalendarDayModule { }
